<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_tit"><a id="page_xv">ACKNOWLEDGMENTS</a></p><a id="page_xv">
<p class="noindent">Thanks to those subscribers to The Direct Response Letter who asked me questions and suggested topics that sparked the essays in these chapters.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_ack.vue?24439c54